import { render, staticRenderFns } from "./addproduct.vue?vue&type=template&id=4be24169&"
import script from "./addproduct.vue?vue&type=script&lang=js&"
export * from "./addproduct.vue?vue&type=script&lang=js&"
import style0 from "./addproduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\project_nav_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4be24169')) {
      api.createRecord('4be24169', component.options)
    } else {
      api.reload('4be24169', component.options)
    }
    module.hot.accept("./addproduct.vue?vue&type=template&id=4be24169&", function () {
      api.rerender('4be24169', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/productVavigation/components/addproduct.vue"
export default component.exports